(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('ProfessionalArea', ProfessionalArea);

    ProfessionalArea.$inject = ['$resource'];

    function ProfessionalArea ($resource) {
        var resourceUrl =  'api/professional-areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
